import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { AuthStore } from './types'
import { initialAuthState } from './state'
import { createAuthActions } from './actions'

export const useAuthStore = create<AuthStore>()(
  persist(
    (...a) => ({
      ...initialAuthState,
      ...createAuthActions(...a),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        authToken: state.authToken,
        refreshToken: state.refreshToken,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      },
    }
  )
)

export * from './selectors'
export type { AuthState, AuthActions, AuthStore } from './types'
